export type DriverRouteKey = 'entry' | 'offers' | 'voucher' | 'vouchers' | 'reviews'

export const DRIVER_PRIMARY_PATHS = {
  entry: '/motorista-aplicativo',
  offers: '/motorista-aplicativo/ofertas',
  voucher: '/motorista-aplicativo/voucher',
  vouchers: '/motorista-aplicativo/vouchers',
  reviews: '/motorista-aplicativo/avaliacoes',
} as const

export const DRIVER_ALIAS_PATHS = {
  entry: '/ofertas',
  offers: '/ofertas/lista',
  voucher: '/ofertas/voucher',
  vouchers: '/ofertas/vouchers',
  reviews: '/ofertas/avaliacoes',
} as const

function clean_path(path: string): string {
  const withoutQuery = String(path || '').split('?')[0] ?? ''
  return (withoutQuery.split('#')[0] ?? '') || '/'
}

export function is_driver_flow_path(path: string): boolean {
  const clean = clean_path(path)
  return Object.values(DRIVER_PRIMARY_PATHS).includes(clean as typeof DRIVER_PRIMARY_PATHS[keyof typeof DRIVER_PRIMARY_PATHS])
    || Object.values(DRIVER_ALIAS_PATHS).includes(clean as typeof DRIVER_ALIAS_PATHS[keyof typeof DRIVER_ALIAS_PATHS])
}

export function is_driver_offers_path(path: string): boolean {
  const clean = clean_path(path)
  return clean === DRIVER_PRIMARY_PATHS.offers || clean === DRIVER_ALIAS_PATHS.offers
}

function use_alias_paths(path: string): boolean {
  return clean_path(path).startsWith('/ofertas')
}

export function driver_path(route: DriverRouteKey, contextPath = window.location.pathname): string {
  const paths = use_alias_paths(contextPath) ? DRIVER_ALIAS_PATHS : DRIVER_PRIMARY_PATHS
  return paths[route]
}
